import Icon from 'src/components/Icon/Icon';
import { observer } from 'src/utils/mobx-react';
import React, { ChangeEvent } from 'react';
import { SinglesVisibleColumnIdsType } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesWidgets/LiabilitiesWidgetTable/LiabilitiesWidgetTable.types';

type TableSubMenuPropsType = {
    handleClose: VoidFunction;
    setTableView: (view: SinglesVisibleColumnIdsType) => void;
    view: string;
    isMultiplesWidget: boolean;
};

export const TableSubMenu = observer(
    'LiabilitiesTableSubMenu',
    ({ handleClose, setTableView, view, isMultiplesWidget }: TableSubMenuPropsType): JSX.Element => {
        const handleChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>): void =>
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            setTableView(value as SinglesVisibleColumnIdsType);

        return (
            <div className='liabilities-sub-menu'>
                {isMultiplesWidget ? null : (
                    <>
                        Show:
                        <label>
                            <input
                                type='radio'
                                checked={view === 'default'}
                                onChange={handleChange}
                                value='default'
                            />
                            Basic
                        </label>
                        <label>
                            <input
                                type='radio'
                                checked={view === 'eachWay'}
                                onChange={handleChange}
                                value='eachWay'
                            />
                            Each-way
                        </label>
                        <label>
                            <input
                                type='radio'
                                checked={view === 'cashout'}
                                onChange={handleChange}
                                value='cashout'
                            />
                            Cash Out
                        </label>
                        <label>
                            <input
                                type='radio'
                                checked={view === 'freebet'}
                                onChange={handleChange}
                                value='freebet'
                            />
                            Free Bets
                        </label>
                    </>
                )}
                <button
                    className='liabilities-close'
                    onClick={handleClose}
                    data-test='close-liabilities'
                >
                    Close Liabilities
                    <Icon name='exit' />
                </button>
            </div>
        );
    }
);
